/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateUserSessionIssuerForm,
  CreateUserSessionIssuerForm$Outbound,
  CreateUserSessionIssuerForm$outboundSchema,
} from "../components/createusersessionissuerform.js";

export type CreateUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateUserSessionIssuerSecurity = {
  option1?: CreateUserSessionIssuerSecurityOption1 | undefined;
  option2?: CreateUserSessionIssuerSecurityOption2 | undefined;
};

export type CreateUserSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createUserSessionIssuerForm: CreateUserSessionIssuerForm;
};

/** @internal */
export type CreateUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerSecurityOption1$Outbound,
    CreateUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function createUserSessionIssuerSecurityOption1ToJSON(
  createUserSessionIssuerSecurityOption1:
    CreateUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerSecurityOption1$outboundSchema.parse(
      createUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    CreateUserSessionIssuerSecurityOption2$Outbound,
    CreateUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function createUserSessionIssuerSecurityOption2ToJSON(
  createUserSessionIssuerSecurityOption2:
    CreateUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerSecurityOption2$outboundSchema.parse(
      createUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerSecurity$Outbound = {
  Option1?: CreateUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: CreateUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  CreateUserSessionIssuerSecurity$Outbound,
  CreateUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createUserSessionIssuerSecurityToJSON(
  createUserSessionIssuerSecurity: CreateUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerSecurity$outboundSchema.parse(
      createUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type CreateUserSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateUserSessionIssuerForm: CreateUserSessionIssuerForm$Outbound;
};

/** @internal */
export const CreateUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  CreateUserSessionIssuerRequest$Outbound,
  CreateUserSessionIssuerRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createUserSessionIssuerForm: CreateUserSessionIssuerForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createUserSessionIssuerForm: "CreateUserSessionIssuerForm",
    });
  }),
);

export function createUserSessionIssuerRequestToJSON(
  createUserSessionIssuerRequest: CreateUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    CreateUserSessionIssuerRequest$outboundSchema.parse(
      createUserSessionIssuerRequest,
    ),
  );
}
